import AsyncDropDown from './AsyncDropDown';

class DropdownBranch extends AsyncDropDown {
    constructor(props: any) {
        super(props);
        const myState = {
            key: props.key !== undefined ? props.key : 'branch_code',
            limit: 10,
            page: 1,
            sortBy: props.sortBy !== undefined ? props.sortBy : 'branch_code',
            sortDir: props.sortDir !== undefined ? props.sortDir : 'asc',
            filters: props.filters !== undefined ? props.filters : {},
            isClearable: props.isClearable !== undefined ? props.isClearable : true,
            url: '/masterdata-api/branch',
            placeholder:
                props.placeholder !== undefined
                    ? props.placeholder
                    : 'Pilih Cabang',
            template:
                props.template !== undefined
                    ? props.template
                    : '{{branch_name}} ({{branch_code}})',
            selectAll: props.selectAll !== undefined ? props.selectAll : false,
            selectAllLabel:
                props.selectAllLabel !== undefined
                    ? props.selectAllLabel
                    : 'Semua',
        };
        Object.assign(this.state, myState);
    }
}

export default DropdownBranch;
